import CardNotification from './CardNotificacion';

export default CardNotification;